import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChapterReportListLayer from "../components/ChapterReportListLayer";

const ChapterReportListPage = () => {
    return (
        <MasterLayout>
            <ChapterReportListLayer />
        </MasterLayout>
    );
};

export default ChapterReportListPage;
